document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-type="textmedia-slider"]').forEach(function (sliderEl) {
    new Swiper(sliderEl, {
      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        type: "bullets",
        clickable: true
      },
      navigation: {
        nextEl: sliderEl.querySelector('.swiper-button-next'),
        prevEl: sliderEl.querySelector('.swiper-button-prev')
      },
    });
  });
});
